import { LegacyCard, DescriptionList, Page, Layout, SettingToggle, Frame, Text } from "@shopify/polaris";
import {useEffect} from 'react';
import { useState } from 'react';
import {useParams, useHistory} from 'react-router-dom';
import Api from '../../helpers/api';
import ResourceSelectorsSet from "./Selectors/ResourceSelectorsSet";

const ShowUser = props => {
    const history = useHistory();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const {userId} = useParams();

    useEffect(() => {
        setLoading(true);
        Api
            .getUser(userId)
            .then( response => {
                setUser(response.data.user);
            })
            .finally(() => setLoading(false));
    }, []);

    const toggleAdminPrivileges = () => {
        setLoading(true);
        Api
            .toggleAdminPrivileges(userId)
            .then((response) => {
                setUser(response.data.user);
            })
            .finally(() => setLoading(false));
    }

    const toggleOnHoldPrivileges = () => {
        setLoading(true);
        Api
            .toggleOnHoldPrivileges(userId)
            .then((response) => {
                setUser(response.data.user);
            })
            .finally(() => setLoading(false));
    }

    return user && (
        <Frame>
            <Page title={`User`}
                  backAction={{ content: 'Go back', onAction: () => history.go(-1) }}
            >
                <Layout>
                    <Layout.Section variant={"fullWidth"}>
                        <LegacyCard sectioned>
                            <DescriptionList items={[
                                { term: 'Email', 'description': user.email },
                                { term: 'Name', 'description': user.name },
                            ]} />
                        </LegacyCard>
                    </Layout.Section>

                    <Layout.Section variant={"oneHalf"}>
                        <SettingToggle
                            action={{
                                content: user.is_admin ? "Revoke admin privileges" : "Add admin privileges",
                                onAction: toggleAdminPrivileges,
                                loading: loading
                            }}
                            enabled={user.is_admin}
                        >
                            { user.is_admin ? "User has admin privileges" : "User doesn't have admin privileges"}
                        </SettingToggle>
                    </Layout.Section>
                    <Layout.Section variant={"oneHalf"}>
                        <SettingToggle
                            action={{
                                content: user.can_manage_on_hold ? "Revoke On Hold privileges" : "Add On Hold privileges",
                                onAction: toggleOnHoldPrivileges,
                                loading: loading
                            }}
                            enabled={user.can_manage_on_hold}
                        >
                            { user.can_manage_on_hold ? "User has On Hold privileges" : "User doesn't have On Hold privileges"}
                        </SettingToggle>
                    </Layout.Section>

                    <Layout.Section>
                        <ResourceSelectorsSet
                            resourceName={{ singular: 'customer', plural: 'customers' }}
                            searchPlaceholder={"Search by name, phone or email address"}
                            leftCardTitle={"Find customers"}
                            rightCardTitle={"Has permissions to Customers"}
                            onAdd={(customerId) => Api.addUserCustomer(userId, customerId)}
                            onRemove={(customerId) => Api.removeUserCustomer(userId, customerId)}
                            onLoadLeftResources={Api.findCustomer}
                            onLoadRightResources={(params) => Api.findUserCustomers(userId, params)}
                            renderItem={item => <>
                                <h3>
                                    <Text variant="strong" variant="bodyMd" as="span">{`${item.additional_data.first_name} ${item.additional_data.last_name}`}</Text>
                                </h3>
                                <div>{`Phone: ${item.additional_data.home_phone} - Email: ${item.email}`}</div>
                            </>}
                        />
                    </Layout.Section>

                    <Layout.Section>
                        <ResourceSelectorsSet
                            resourceName={{ singular: 'company', plural: 'companies' }}
                            searchPlaceholder={"Search by name"}
                            leftCardTitle={"Find companies"}
                            rightCardTitle={"Has permissions to Companies"}
                            onAdd={(companyId) => Api.addUserCompany(userId, companyId)}
                            onRemove={(companyId) => Api.removeUserCompany(userId, companyId)}
                            onLoadLeftResources={Api.findCompanies}
                            onLoadRightResources={(params) => Api.findUserCompanies(userId, params)}
                            renderItem={item => <h3><Text variant="strong" variant="bodyMd" as="span">{`${item.name}`}</Text></h3>}
                        />
                    </Layout.Section>
                </Layout>
            </Page>
        </Frame>
    );
}

export default ShowUser;
